import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { ContractContactDetails } from 'src/app/model/account/user-otp-request';
import { GTMOnboardingEvents, OnboardingSteps } from 'src/app/model/google-tag-manager/api-status';

@Component({
  selector: 'app-review-address',
  templateUrl: './review-address.component.html',
  styleUrls: ['./review-address.component.scss']
})

export class ReviewAddressComponent implements OnInit {
  @Input() contactInfo: ContractContactDetails = new ContractContactDetails();
  @Output() reviewAddressResponse = new EventEmitter();

  public isSPOEEnabled = false;
  public formattedPhoneNumber:string='';

  constructor(
    public resourceService: ADPResourceService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
    this.formattedPhoneNumber = this.formatPhoneNumber(this.contactInfo.phone);
    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.InProcess, OnboardingSteps.ReviewAddress);
    if (!this.contactInfo.phone || !this.contactInfo.addressLine1) {
      this.reviewAddressResponse.emit(true);
    }
  }

  onEdit() {
    this.reviewAddressResponse.emit(true);
  }

  confirm() {
    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.ReviewAddress);
    this.reviewAddressResponse.emit(false);
  }

  formatPhoneNumber(phoneNumberString: string): string {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumberString;
  }

}
